import dd4137 from '@/components/forms/dd4137/index.vue'

const install = function(Vue) {
  Vue.component('mct-form-dd4137', dd4137)
}

export default { install }
